/* =====================================================================
   SUNBORN — CART DRAWER SCRIPTS (moved out of snippets/ajax-cart.liquid)
   9/27 PageSpeed: these two blocks used to be pasted INLINE into every
   page's HTML (~48KB per page, re-downloaded on every navigation and on
   every ?sections=ajax-cart refresh). Moved here verbatim so the browser
   downloads them once and caches them. Loaded with defer from
   snippets/ajax-cart.liquid — deferred scripts run before
   DOMContentLoaded, so both DOMContentLoaded handlers below still fire in
   the same order as before (block 1 defines window.sbRefreshDrawer, block
   2 wraps it). Pure JS, no Liquid — safe as a static asset.
   Block 1: saved-for-later, drawer refresh, add-back / buy-now, discount
            apply/remove, You May Also Like (sb-ctk) carousel + related recs.
   Block 2: line-item size/color swapper (sbSwap) + size-guide modal.
   9/30: sbSwapVariant now swaps in ONE atomic /cart/update.js call (no
         /cart/add.js), so drawer size/color swaps no longer fire a fake
         Add To Cart to Meta/TikTok/Pinterest pixels.
   9/30 (page load): the drawer's network work — the line-item swapper
         (/cart.js + /products/<h>.js per line), the You May Also Like
         related-recs rebuild (/products/<h>.js + /recommendations per line)
         and the active-discount sync (/cart.js) — used to run on EVERY page
         load whenever the cart had items, even if the shopper never opened
         the cart. It now waits for cart intent (window.sbWhenCartIntent):
         the drawer opening (incl. every Add To Cart), or hover / touch /
         focus on the cart icon. The drawer's Liquid-rendered content (items,
         prices, fallback You May Also Like) is unchanged and shows
         immediately; only the JS enhancements load on intent.
   9/30 (no collapse): sbRefreshDrawer used to copy the freshly rendered
         <ajax-cart> className over the live one, which dropped the
         "active"/"animate" classes — the drawer slid shut — and then called
         open(), which slid it back in. Every in-drawer action (size/color
         swap, You May Also Like add, discount apply, wishlist add-back)
         visibly collapsed and reopened the drawer. Now: if the drawer is
         already open it stays open (state classes kept, open() skipped), and
         the scroll position inside the drawer is preserved across the
         re-render.
   9/30 (stable line order): assets/sunborn-cart-order.js may re-order the
         .cart-item nodes so a swapped line keeps its slot. sbSwapInjectAll
         therefore matches each DOM line to its cart line by variant id
         (data-quantity-variant-id), not by position.
===================================================================== */

/* ---------- Cart-intent gate ---------- */
(function () {
  var fired = false;
  var queue = [];

  function isEmpty() {
    var s = document.querySelector('ajax-cart');
    return !s || s.classList.contains('is-empty');
  }

  function fire() {
    if (fired) return;
    fired = true;
    var q = queue;
    queue = [];
    q.forEach(function (fn) {
      try { fn(); } catch (e) { console.error('SunBorn cart intent task failed:', e); }
    });
  }

  window.sbWhenCartIntent = function (fn) {
    if (fired) { fn(); return; }
    queue.push(fn);
  };
  window.sbCartIntentFired = function () { return fired; };
  window.sbCartIntentFire = fire;

  document.addEventListener('DOMContentLoaded', function () {
    var shell = document.querySelector('ajax-cart');
    if (shell) {
      if (shell.classList.contains('active')) fire();
      new MutationObserver(function () {
        if (shell.classList.contains('active')) fire();
      }).observe(shell, { attributes: true, attributeFilter: ['class'] });
    }
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('#ajax-cart-icon, .ajax-cart-icon, a[href="/cart"]') && !isEmpty()) fire();
      }, { passive: true, capture: true });
    });
  });
})();

/* ---------- Block 1 ---------- */
document.addEventListener('DOMContentLoaded', function () {
    function sbMoney(cents) {
      try {
        return Shopify.formatMoney(cents, window.money_format);
      } catch (e) {
        return cents;
      }
    }

    function sbRenderSavedForLater() {
      var container = document.getElementById('sb-saved-for-later');
      var listEl = document.getElementById('sb-saved-list');
      if (!container || !listEl || !window.SBWishlist) return;

      var arr = window.SBWishlist.getArray();
      var countEl = container.querySelector('.sb-saved-count');

      if (!arr.length) {
        container.hidden = true;
        listEl.innerHTML = '';
        return;
      }

      container.hidden = false;
      if (countEl) countEl.textContent = '(' + arr.length + ')';

      listEl.innerHTML = arr.map(function (raw) {
        var e = window.SBWishlist.normalize(raw);
        var imgHtml = e.image
          ? '<img src="' + e.image + '" alt="" loading="lazy">'
          : '';
        var priceHtml = e.price ? sbMoney(e.price) : '';
        var variantHtml = e.variantTitle && e.variantTitle !== 'Default Title'
          ? '<span class="sb-saved-item-variant">' + e.variantTitle + '</span>'
          : '';
        return (
          '<div class="sb-saved-item">' +
            '<span class="sb-saved-item-img">' + imgHtml + '</span>' +
            '<span class="sb-saved-item-info">' +
              '<span class="sb-saved-item-title">' + (e.productTitle || '') + '</span>' +
              variantHtml +
              '<span class="sb-saved-item-price">' + priceHtml + '</span>' +
            '</span>' +
            '<span class="sb-saved-item-actions">' +
              '<span class="sb-saved-btn-stack">' +
                '<button type="button" class="sb-saved-add-btn" data-variant-id="' + e.variantId + '" data-handle="' + e.handle + '">Add to Cart</button>' +
                '<button type="button" class="sb-saved-buy-btn" data-variant-id="' + e.variantId + '">Buy Now</button>' +
              '</span>' +
              '<a href="#" class="sb-saved-remove" data-handle="' + e.handle + '" aria-label="Remove from wishlist">' +
                '<i class="feather-trash-2"></i>' +
              '</a>' +
            '</span>' +
          '</div>'
        );
      }).join('');
    }

    sbRenderSavedForLater();

    window.addEventListener('sunborn:wishlist-change', sbRenderSavedForLater);

    var cartIconEl = document.getElementById('ajax-cart-icon');
    if (cartIconEl) {
      cartIconEl.addEventListener('click', function () {
        sbRenderSavedForLater();
        sbMaybeRebuildRelatedRecs();
      });
    }

    var ajaxRoot = document.getElementById('ajaxcart');
    if (ajaxRoot && 'MutationObserver' in window) {
      var sbRerenderQueued = false;
      new MutationObserver(function (mutations) {
        /* 9/30: no network work until the shopper shows cart intent */
        if (window.sbCartIntentFired && !window.sbCartIntentFired()) return;
        var external = false;
        for (var i = 0; i < mutations.length; i++) {
          var t = mutations[i].target;
          if (!t.closest || !t.closest('.sb-saved-for-later')) {
            external = true;
            break;
          }
        }
        if (!external || sbRerenderQueued) return;
        sbRerenderQueued = true;
        requestAnimationFrame(function () {
          sbRerenderQueued = false;
          sbRenderSavedForLater();
          sbMaybeRebuildRelatedRecs();
          if (typeof window.sbSwapInjectAll === 'function') {
            window.sbSwapInjectAll();
          }
        });
      }).observe(ajaxRoot, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('.sb-saved-toggle');
      if (!toggleBtn) return;
      var list = document.getElementById('sb-saved-list');
      var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!expanded));
      if (list) list.hidden = expanded;
      toggleBtn.classList.toggle('sb-saved-toggle--open', !expanded);
    });

    function sbRemoveFromWishlist(handle) {
      if (!handle || !window.SBWishlist) return;
      var arr = window.SBWishlist.getArray();
      var idx = window.SBWishlist.findIndex(arr, handle);
      if (idx > -1) {
        arr.splice(idx, 1);
        window.SBWishlist.save(arr);
      }
      document.querySelectorAll(".wishlist[data-handle='" + handle + "']").forEach(function (el) {
        el.classList.remove('active-wishlist');
        el.classList.add('wishlist-custom-action');
      });
      document.querySelectorAll('.wishlist-counter').forEach(function (el) {
        el.textContent = arr.length;
      });
    }

    document.addEventListener('click', function (e) {
      var rm = e.target.closest('.sb-saved-remove');
      if (!rm) return;
      e.preventDefault();
      sbRemoveFromWishlist(rm.getAttribute('data-handle'));
    });

    function sbFlyToCart(itemEl) {
      try {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var img = itemEl ? itemEl.querySelector('.sb-saved-item-img img') : null;
        var target = document.getElementById('ajaxcart-cartitems') || document.querySelector('.header-mini-cart');
        if (!img || !target) return;
        var from = img.getBoundingClientRect();
        var to = target.getBoundingClientRect();
        if (!from.width) return;
        var clone = img.cloneNode(true);
        clone.className = 'sb-fly-clone';
        clone.style.top = from.top + 'px';
        clone.style.left = from.left + 'px';
        clone.style.width = from.width + 'px';
        clone.style.height = from.height + 'px';
        document.body.appendChild(clone);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            var dx = (to.left + 24) - from.left;
            var dy = (to.top + 24) - from.top;
            clone.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.35)';
            clone.style.opacity = '0.15';
          });
        });
        setTimeout(function () {
          if (clone.parentNode) clone.parentNode.removeChild(clone);
        }, 700);
      } catch (err) {}
    }

    function sbHighlightNewestCartItem() {
      var items = document.querySelectorAll('#ajaxcart-cartitems .cart-item');
      if (!items.length) return;
      var last = items[items.length - 1];
      last.classList.add('sb-cart-item-just-added');
      setTimeout(function () {
        last.classList.remove('sb-cart-item-just-added');
      }, 900);
    }

    function sbRefreshDrawer(opts) {
      var highlight = !(opts && opts.noHighlight);
      return fetch(window.location.pathname + '?sections=ajax-cart,ajax-cart-icon')
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          var parser = new DOMParser();
          var currentShell = document.querySelector('ajax-cart');
          var wasOpen = !!(currentShell && currentShell.classList.contains('active'));
          var scrollEl = document.querySelector('#ajaxcart .sb-cart-scroll-zone');
          var scrollTop = scrollEl ? scrollEl.scrollTop : 0;

          if (sections['ajax-cart']) {
            var doc = parser.parseFromString(sections['ajax-cart'], 'text/html');
            var fresh = doc.querySelector('#ajaxcart');
            var current = document.querySelector('#ajaxcart');
            if (fresh && current) {
              current.innerHTML = fresh.innerHTML;
            }
            var freshShell = doc.querySelector('ajax-cart');
            if (freshShell && currentShell) {
              /* 9/30: keep the live open-state classes so the drawer doesn't slide shut */
              var keep = [];
              ['active', 'animate'].forEach(function (c) {
                if (currentShell.classList.contains(c)) keep.push(c);
              });
              currentShell.className = freshShell.className;
              keep.forEach(function (c) { currentShell.classList.add(c); });
            }
            if (typeof window.sbCartReorder === 'function') window.sbCartReorder();
            if (wasOpen) {
              var newScrollEl = document.querySelector('#ajaxcart .sb-cart-scroll-zone');
              if (newScrollEl) newScrollEl.scrollTop = scrollTop;
            }
          }

          if (sections['ajax-cart-icon']) {
            var doc2 = parser.parseFromString(sections['ajax-cart-icon'], 'text/html');
            var freshSection = doc2.querySelector('.shopify-section');
            var iconTarget = document.getElementById('ajax-cart-icon');
            if (freshSection && iconTarget) {
              iconTarget.innerHTML = freshSection.innerHTML;
            }
          }

          var ajaxCartEl = document.querySelector('ajax-cart');
          if (!wasOpen && ajaxCartEl && typeof ajaxCartEl.open === 'function') {
            ajaxCartEl.open();
          }

          sbRenderSavedForLater();
          if (highlight && !wasOpen) sbHighlightNewestCartItem();
          fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(sbSyncActiveDiscount)
            .catch(function () {});
          setTimeout(function () {
            sbMaybeRebuildRelatedRecs(true);
          }, 750);
        });
    }

    window.sbRefreshDrawer = sbRefreshDrawer;

    function sbAddBackToCart(variantId, btnEl) {
      if (!variantId) return;
      var handle = btnEl ? btnEl.getAttribute('data-handle') : '';
      if (btnEl) {
        btnEl.disabled = true;
        btnEl.textContent = 'Adding...';
        sbFlyToCart(btnEl.closest('.sb-saved-item'));
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('SunBorn add-back-to-cart: /cart/add.js failed');
          return res.json();
        })
        .then(function () {
          sbRemoveFromWishlist(handle);
          return sbRefreshDrawer();
        })
        .catch(function (err) {
          console.error('SunBorn add-back-to-cart failed:', err);
          if (btnEl) {
            btnEl.disabled = false;
            btnEl.textContent = 'Add to Cart';
          }
        });
    }

    function sbBuyNow(variantId, btnEl) {
      if (!variantId) return;
      if (btnEl) {
        btnEl.disabled = true;
        btnEl.textContent = 'One sec...';
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('SunBorn buy-now: /cart/add.js failed');
          return res.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.error('SunBorn buy-now failed:', err);
          if (btnEl) {
            btnEl.disabled = false;
            btnEl.textContent = 'Buy Now';
          }
        });
    }

    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.sb-saved-add-btn');
      if (!addBtn) return;
      e.preventDefault();
      sbAddBackToCart(addBtn.getAttribute('data-variant-id'), addBtn);
    });

    document.addEventListener('click', function (e) {
      var buyBtn = e.target.closest('.sb-saved-buy-btn');
      if (!buyBtn) return;
      e.preventDefault();
      sbBuyNow(buyBtn.getAttribute('data-variant-id'), buyBtn);
    });

    function sbSyncActiveDiscount(cart) {
      var activeWrap = document.getElementById('sb-discount-active');
      var activeCode = document.getElementById('sb-discount-active-code');
      var inputRow = document.getElementById('sb-discount-input-row');
      if (!activeWrap || !inputRow) return;

      var codes = cart && cart.discount_codes;
      var applied = Array.isArray(codes)
        ? codes.find(function (d) { return d && d.applicable !== false; })
        : null;

      if (applied) {
        if (activeCode) activeCode.textContent = applied.code;
        activeWrap.hidden = false;
        inputRow.hidden = true;
      } else {
        activeWrap.hidden = true;
        inputRow.hidden = false;
      }
    }

    function sbRemoveActiveDiscount(btnEl) {
      if (btnEl) btnEl.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '' })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          sbSyncActiveDiscount(cart);
          var msg = document.getElementById('sb-discount-msg');
          if (msg) msg.hidden = true;
        })
        .catch(function (err) {
          console.error('SunBorn remove-discount failed:', err);
        })
        .finally(function () {
          if (btnEl) btnEl.disabled = false;
        });
    }

    window.sbSyncActiveDiscount = sbSyncActiveDiscount;
    window.sbRemoveActiveDiscount = sbRemoveActiveDiscount;

    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('#sb-discount-remove');
      if (!removeBtn) return;
      e.preventDefault();
      sbRemoveActiveDiscount(removeBtn);
    });

    /* 9/30: the drawer's Liquid already renders the applied code; the live
       re-check waits for cart intent instead of running on every page load. */
    window.sbWhenCartIntent(function () {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(sbSyncActiveDiscount)
        .catch(function () {});
    });

    function sbApplyDiscount(applyBtn) {
      var wrap = applyBtn.closest('.sb-cart-discount-wrap');
      var input = wrap ? wrap.querySelector('.sb-cart-discount-input') : null;
      var msg = wrap ? wrap.querySelector('.sb-cart-discount-msg') : null;
      var code = input ? input.value.trim() : '';
      if (!code) return;

      applyBtn.disabled = true;
      applyBtn.textContent = '...';

      function showMsg(text, ok) {
        if (msg) {
          msg.hidden = false;
          msg.textContent = text;
          msg.classList.toggle('is-ok', !!ok);
        }
        applyBtn.disabled = false;
        applyBtn.textContent = 'Apply';
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var codes = cart && cart.discount_codes;
          var applied = Array.isArray(codes) && codes.some(function (d) {
            return d && d.code && d.code.toLowerCase() === code.toLowerCase() && d.applicable !== false;
          });
          if (applied) {
            sbSyncActiveDiscount(cart);
            return sbRefreshDrawer();
          }
          return fetch('/discount/' + encodeURIComponent(code)).then(function () {
            showMsg('Code saved \u2014 it will be applied at checkout if valid.', true);
          });
        })
        .catch(function () {
          fetch('/discount/' + encodeURIComponent(code))
            .then(function () {
              showMsg('Code saved \u2014 it will be applied at checkout if valid.', true);
            })
            .catch(function () {
              showMsg('Couldn\u2019t save that code \u2014 you can enter it at checkout.', false);
            });
        });
    }

    document.addEventListener('click', function (e) {
      var applyBtn = e.target.closest('.sb-cart-discount-apply');
      if (!applyBtn) return;
      e.preventDefault();
      sbApplyDiscount(applyBtn);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest ? e.target.closest('.sb-cart-discount-input') : null;
      if (!input) return;
      e.preventDefault();
      var wrap = input.closest('.sb-cart-discount-wrap');
      var applyBtn = wrap ? wrap.querySelector('.sb-cart-discount-apply') : null;
      if (applyBtn) sbApplyDiscount(applyBtn);
    });

    function sbCtkScrollByCard(track, dir) {
      if (!track) return;
      var card = track.querySelector('.sb-ctk-card');
      var cardWidth = card ? card.getBoundingClientRect().width : track.clientWidth / 2;
      var gap = 10;
      track.scrollBy({ left: dir * (cardWidth + gap), behavior: 'smooth' });
    }

    document.addEventListener('click', function (e) {
      var arrow = e.target.closest('.sb-ctk-arrow');
      if (!arrow) return;
      var viewport = arrow.closest('.sb-ctk-viewport');
      var track = viewport ? viewport.querySelector('.sb-ctk-track') : null;
      sbCtkScrollByCard(track, arrow.classList.contains('sb-ctk-arrow-next') ? 1 : -1);
    });

    var sbCtkDrag = { active: false, trackEl: null, startX: 0, startScrollLeft: 0, moved: false };

    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var track = e.target.closest('.sb-ctk-track');
      if (!track) return;
      e.preventDefault();
      sbCtkDrag.active = true;
      sbCtkDrag.trackEl = track;
      sbCtkDrag.startX = e.pageX;
      sbCtkDrag.startScrollLeft = track.scrollLeft;
      sbCtkDrag.moved = false;
      track.classList.add('sb-ctk-dragging');
    });

    document.addEventListener('dragstart', function (e) {
      if (e.target.closest && e.target.closest('.sb-ctk-track')) {
        e.preventDefault();
      }
    });

    document.addEventListener('pointermove', function (e) {
      if (!sbCtkDrag.active || !sbCtkDrag.trackEl) return;
      var dx = e.pageX - sbCtkDrag.startX;
      if (Math.abs(dx) > 4) sbCtkDrag.moved = true;
      if (!sbCtkDrag.moved) return;
      e.preventDefault();
      sbCtkDrag.trackEl.scrollLeft = sbCtkDrag.startScrollLeft - dx;
    });

    function sbCtkEndDrag() {
      if (!sbCtkDrag.active) return;
      if (sbCtkDrag.trackEl) sbCtkDrag.trackEl.classList.remove('sb-ctk-dragging');
      sbCtkDrag.active = false;
      sbCtkDrag.trackEl = null;
      setTimeout(function () {
        sbCtkDrag.moved = false;
      }, 0);
    }

    document.addEventListener('pointerup', sbCtkEndDrag);
    document.addEventListener('pointercancel', sbCtkEndDrag);

    document.addEventListener('click', function (e) {
      if (sbCtkDrag.moved && e.target.closest('.sb-ctk-track')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    function sbCtkFlyToCart(imgEl) {
      try {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var itemsContainer = document.getElementById('ajaxcart-cartitems');
        var items = itemsContainer ? itemsContainer.querySelectorAll('.cart-item') : [];
        var target = items.length
          ? items[items.length - 1]
          : (itemsContainer || document.querySelector('.header-mini-cart'));
        if (!imgEl || !target) return;
        var from = imgEl.getBoundingClientRect();
        var to = target.getBoundingClientRect();
        if (!from.width) return;
        var clone = imgEl.cloneNode(true);
        clone.className = 'sb-fly-clone';
        clone.style.top = from.top + 'px';
        clone.style.left = from.left + 'px';
        clone.style.width = from.width + 'px';
        clone.style.height = from.height + 'px';
        document.body.appendChild(clone);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            var dx = (to.left + 24) - from.left;
            var dy = (to.bottom - 20) - from.top;
            clone.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.3)';
            clone.style.opacity = '0';
          });
        });
        setTimeout(function () {
          if (clone.parentNode) clone.parentNode.removeChild(clone);
        }, 700);
      } catch (err) {}
    }

    function sbCtkAddVariant(variantId, cardEl, controlEl) {
      if (!variantId) return;
      var img = cardEl ? cardEl.querySelector('.sb-ctk-card-img img') : null;
      if (controlEl) {
        controlEl.disabled = true;
        controlEl.classList.add('is-loading');
      }
      sbCtkFlyToCart(img);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('SunBorn You May Also Like: /cart/add.js failed');
          return res.json();
        })
        .then(function () {
          return sbRefreshDrawer();
        })
        .catch(function (err) {
          console.error('SunBorn You May Also Like add failed:', err);
          if (controlEl) {
            controlEl.disabled = false;
            controlEl.classList.remove('is-loading');
          }
        });
    }

    function sbCtkCloseAllSizeOverlays(except) {
      document.querySelectorAll('.sb-ctk-sizes').forEach(function (el) {
        if (el === except) return;
        el.hidden = true;
        var card = el.closest('.sb-ctk-card');
        var btn = card ? card.querySelector('.sb-ctk-atc-reveal') : null;
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (card) card.classList.remove('sb-ctk-card--sizes-open');
      });
    }

    document.addEventListener('click', function (e) {
      var revealBtn = e.target.closest('.sb-ctk-atc-reveal');
      if (revealBtn) {
        e.preventDefault();
        var card = revealBtn.closest('.sb-ctk-card');
        var overlay = card ? card.querySelector('.sb-ctk-sizes') : null;
        if (!overlay) return;
        var willOpen = overlay.hidden;
        sbCtkCloseAllSizeOverlays(willOpen ? overlay : null);
        overlay.hidden = !willOpen;
        revealBtn.setAttribute('aria-expanded', String(willOpen));
        card.classList.toggle('sb-ctk-card--sizes-open', willOpen);
        return;
      }

      var pill = e.target.closest('.sb-ctk-size-pill');
      if (pill) {
        e.preventDefault();
        if (pill.disabled || pill.getAttribute('data-available') !== 'true') return;
        var pillCard = pill.closest('.sb-ctk-card');
        var pillOverlay = pillCard ? pillCard.querySelector('.sb-ctk-sizes') : null;
        if (pillOverlay) pillOverlay.hidden = true;
        if (pillCard) pillCard.classList.remove('sb-ctk-card--sizes-open');
        sbCtkAddVariant(pill.getAttribute('data-variant-id'), pillCard, pill);
        return;
      }

      var atcBtn = e.target.closest('.sb-ctk-atc');
      if (atcBtn && atcBtn.tagName !== 'A') {
        e.preventDefault();
        var variantId = atcBtn.getAttribute('data-variant-id');
        var available = atcBtn.getAttribute('data-available') === 'true';
        if (!variantId || !available || atcBtn.disabled) return;
        sbCtkAddVariant(variantId, atcBtn.closest('.sb-ctk-card'), atcBtn);
        return;
      }

      if (!e.target.closest('.sb-ctk-sizes')) {
        sbCtkCloseAllSizeOverlays(null);
      }
    });

    var sbCtkBuildInFlight = false;
    var sbCtkLastCartSignature = null;

    function sbEscapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str == null ? '' : String(str);
      return div.innerHTML;
    }

    function sbCdnResize(url, width) {
      if (!url) return '';
      try {
        var u = new URL(url, window.location.origin);
        u.searchParams.set('width', width);
        return u.toString();
      } catch (e) {
        return url;
      }
    }

    function sbExtractGenderTag(tags) {
      if (!Array.isArray(tags)) return null;
      for (var i = 0; i < tags.length; i++) {
        var m = /^\s*Gender:\s*(.+)\s*$/i.exec(tags[i]);
        if (m) return m[1].trim();
      }
      return null;
    }

    function sbOptionName(opt) {
      if (typeof opt === 'string') return opt;
      if (opt && typeof opt === 'object' && typeof opt.name === 'string') return opt.name;
      return '';
    }

    var SB_CTK_COLOR_LABELS = [
      'color', 'colour', 'couleur', 'cor', 'colore', 'farbe',
      '색', '色', 'カラー', 'färg', 'farve', 'szín', 'barva'
    ];

    function sbCtkNonColorOptionIndexes(product) {
      var options = product.options || [];
      var indexes = [];
      options.forEach(function (opt, idx) {
        var down = sbOptionName(opt).toLowerCase();
        if (SB_CTK_COLOR_LABELS.indexOf(down) === -1) indexes.push(idx);
      });
      return indexes;
    }

    function sbCtkBuildSizePills(product, optionIndex) {
      var key = 'option' + (optionIndex + 1);
      var seen = {};
      var pills = [];
      (product.variants || []).forEach(function (v) {
        var val = v[key];
        if (val == null || seen[val]) return;
        seen[val] = true;
        pills.push({ value: val, variant: v });
      });
      return pills;
    }

    var sbCtkAtcSvg =
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M6 6h15l-1.5 9h-12L6 6Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M6 6 5 3H2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '<circle cx="9.5" cy="20" r="1.5" fill="currentColor"/>' +
      '<circle cx="17.5" cy="20" r="1.5" fill="currentColor"/>' +
      '<path d="M10 9v3M8.5 10.5h3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '</svg>';

    function sbCtkDirectAtcHtml(variant, titleEsc) {
      return (
        '<button type="button" class="sb-ctk-atc" data-variant-id="' + (variant.id || '') + '" ' +
        'data-available="' + (variant.available ? 'true' : 'false') + '" ' +
        'aria-label="Add ' + titleEsc + ' to cart">' + sbCtkAtcSvg + '</button>'
      );
    }

    var SB_SP_ICONS = {
      fire: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2c1 3-2 4-2 7a4 4 0 0 0 8 0c0-1-.3-2-1-3 2 1 3 3.5 3 6a8 8 0 1 1-16 0c0-4 2-7 5-8 1-.3 2.2-1.2 3-2Z"/></svg>',
      eye: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>',
      bolt: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z"/></svg>',
      trophy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 21h8M12 17v4M7 4h10v4a5 5 0 0 1-10 0V4Z"/><path d="M17 5h3a3 3 0 0 1-3 5M7 5H4a3 3 0 0 0 3 5"/></svg>',
      star: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1L12 2Z"/></svg>',
      heart: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.5-4.6-10-9.2C.5 8.4 2.4 5 6 5c2 0 3.5 1.1 4.3 2.1l1.7 2 1.7-2C14.5 6.1 16 5 18 5c3.6 0 5.5 3.4 4 6.8-2.5 4.6-10 9.2-10 9.2Z"/></svg>'
    };

    function sbComputeSocialProof(product) {
      var seed = (product.id || 0) % 97;
      var iconKey = 'fire';
      (product.tags || []).forEach(function (tag) {
        var t = String(tag).toLowerCase();
        if (t === 'sp-icon-fire') iconKey = 'fire';
        else if (t === 'sp-icon-eye') iconKey = 'eye';
        else if (t === 'sp-icon-bolt') iconKey = 'bolt';
        else if (t === 'sp-icon-trophy') iconKey = 'trophy';
        else if (t === 'sp-icon-star') iconKey = 'star';
        else if (t === 'sp-icon-heart') iconKey = 'heart';
      });

      var baselineMin = 3, baselineMax = 18;
      var baselineRange = baselineMax - baselineMin + 1;
      var soldCount = (seed % baselineRange) + baselineMin;

      var createdTs = product.created_at ? new Date(product.created_at).getTime() / 1000 : (Date.now() / 1000);
      var nowTs = Date.now() / 1000;
      var daysOld = Math.floor((nowTs - createdTs) / 86400);
      var daysOldCapped = Math.min(daysOld, 60);

      var velocityMax = 2;
      var dailyVelocity = (seed % velocityMax) + 1;
      var velocityAdd = Math.floor((daysOldCapped * dailyVelocity) / 3);
      soldCount += velocityAdd;

      var newBoostDays = 14, newBoost = 5;
      if (daysOld < newBoostDays) soldCount += newBoost;

      var capMin = 40, capMax = 75;
      var capRange = capMax - capMin + 1;
      var productCap = (seed % capRange) + capMin;
      soldCount = Math.min(soldCount, productCap);

      return { iconSvg: SB_SP_ICONS[iconKey] || SB_SP_ICONS.fire, soldCount: soldCount };
    }

    function sbCtkSocialProofHtml(product) {
      var sp = sbComputeSocialProof(product);
      return (
        '<div class="sb-sp-badge" data-icon="social" data-product-id="' + (product.id || '') + '" data-base-count="' + sp.soldCount + '" role="button" tabindex="0" aria-label="' + sp.soldCount + ' sold">' +
          '<span class="sb-sp-badge-icon">' + sp.iconSvg + '</span>' +
          '<span class="sb-sp-badge-count">' + sp.soldCount + '</span>' +
        '</div>'
      );
    }

    function sbCtkRatingHtml(product) {
      return (
        '<div class="sb-ctk-rating">' +
          '<div class="jdgm-prev-badge jdgm--js" data-id="' + (product.id || '') + '" data-average-rating="">' +
            '<span class="jdgm-prev-badge__stars" data-score="0.00">' +
              '<span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span>' +
              '<span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span>' +
              '<span class="jdgm-star jdgm--off"></span>' +
            '</span>' +
          '</div>' +
        '</div>'
      );
    }

    function sbCtkCardMarkup(product) {
      var variants = product.variants || [];
      var variant = variants.find(function (v) { return v.available; }) || variants[0] || {};
      var hasOnlyOneVariant = variants.length <= 1;
      var imgUrl = sbCdnResize(product.featured_image, 300);
      var titleEsc = sbEscapeHtml(product.title);
      var urlEsc = sbEscapeHtml(product.url);
      var priceHtml = sbMoney(variant.price != null ? variant.price : product.price);

      var atcHtml;
      if (hasOnlyOneVariant) {
        atcHtml = sbCtkDirectAtcHtml(variant, titleEsc);
      } else {
        var nonColorIdx = sbCtkNonColorOptionIndexes(product);

        if (nonColorIdx.length >= 2) {
          atcHtml =
            '<a href="' + urlEsc + '" class="sb-ctk-atc sb-ctk-atc-link" ' +
            'aria-label="View sizing options for ' + titleEsc + '">' + sbCtkAtcSvg + '</a>';
        } else if (nonColorIdx.length === 1) {
          var pills = sbCtkBuildSizePills(product, nonColorIdx[0]);
          var pillsHtml = pills.map(function (p) {
            var label = sbEscapeHtml(p.value);
            var v = p.variant;
            return (
              '<button type="button" class="sb-ctk-size-pill" ' +
              'data-variant-id="' + v.id + '" ' +
              'data-available="' + (v.available ? 'true' : 'false') + '"' +
              (v.available ? '' : ' disabled') +
              '>' + label + '</button>'
            );
          }).join('');
          atcHtml =
            '<button type="button" class="sb-ctk-atc sb-ctk-atc-reveal" ' +
            'aria-label="Choose a size for ' + titleEsc + '" aria-expanded="false">' + sbCtkAtcSvg + '</button>' +
            '<div class="sb-ctk-sizes" hidden>' +
              '<span class="sb-ctk-sizes-label">Select size</span>' +
              '<div class="sb-ctk-sizes-list">' + pillsHtml + '</div>' +
            '</div>';
        } else {
          atcHtml = sbCtkDirectAtcHtml(variant, titleEsc);
        }
      }

      return (
        '<div class="sb-ctk-card">' +
          '<div class="sb-ctk-card-img">' +
            '<a href="' + urlEsc + '" tabindex="-1" aria-hidden="true">' +
              (imgUrl ? '<img src="' + imgUrl + '" loading="lazy" alt="">' : '') +
            '</a>' +
            sbCtkSocialProofHtml(product) +
            atcHtml +
          '</div>' +
          '<a href="' + urlEsc + '" class="sb-ctk-card-title">' + titleEsc + '</a>' +
          '<span class="sb-ctk-card-price">' + priceHtml + '</span>' +
          sbCtkRatingHtml(product) +
        '</div>'
      );
    }

    async function sbFetchJson(url) {
      var res = await fetch(url);
      if (!res.ok) throw new Error('SunBorn You May Also Like: request failed (' + res.status + ') ' + url);
      return res.json();
    }

    async function sbBuildRelatedRecs(cart) {
      var track = document.getElementById('sb-ctk-track');
      var wrap = document.getElementById('sb-ctk');
      if (!track || !wrap || !cart || !cart.items || !cart.items.length) return;
      if (sbCtkBuildInFlight) return;
      sbCtkBuildInFlight = true;

      try {
        var cartProductIds = {};
        var uniqueHandles = [];
        var seenHandles = {};
        cart.items.forEach(function (item) {
          cartProductIds[item.product_id] = true;
          if (!seenHandles[item.handle]) {
            seenHandles[item.handle] = true;
            uniqueHandles.push(item.handle);
          }
        });

        var allowedGenders = { Unisex: true };
        var relatedLists = [];

        await Promise.all(uniqueHandles.map(async function (handle) {
          try {
            var product = await sbFetchJson('/products/' + handle + '.js');
            var g = sbExtractGenderTag(product.tags);
            if (g) allowedGenders[g] = true;

            var recs = await sbFetchJson(
              '/recommendations/products.json?product_id=' + product.id + '&intent=related&limit=10'
            );
            relatedLists.push(recs.products || []);
          } catch (innerErr) {
            console.error('SunBorn You May Also Like: per-item fetch failed', innerErr);
            relatedLists.push([]);
          }
        }));

        var merged = [];
        var maxLen = relatedLists.reduce(function (m, l) { return Math.max(m, l.length); }, 0);
        for (var i = 0; i < maxLen; i++) {
          for (var j = 0; j < relatedLists.length; j++) {
            if (relatedLists[j][i]) merged.push(relatedLists[j][i]);
          }
        }

        var seenIds = {};
        var filtered = [];
        merged.forEach(function (product) {
          if (seenIds[product.id]) return;
          if (cartProductIds[product.id]) return;
          var g = sbExtractGenderTag(product.tags);
          if (g && g !== 'Unisex' && !allowedGenders[g]) return;
          seenIds[product.id] = true;
          filtered.push(product);
        });

        var limited = filtered.slice(0, 8);
        if (!limited.length) return;

        track.innerHTML = limited.map(sbCtkCardMarkup).join('');
        wrap.setAttribute('data-sb-ctk-source', 'related');

        if (window.jdgm && typeof window.jdgm.batchRefresh === 'function') {
          window.jdgm.batchRefresh();
        }
      } catch (err) {
        console.error('SunBorn You May Also Like: related-recs build failed', err);
      } finally {
        sbCtkBuildInFlight = false;
      }
    }

    async function sbMaybeRebuildRelatedRecs(force) {
      var track = document.getElementById('sb-ctk-track');
      if (!track) return;
      try {
        var cart = await sbFetchJson('/cart.js');
        var sig = cart.items
          .map(function (item) { return item.id + ':' + item.quantity; })
          .sort()
          .join('|');
        if (!force && sig === sbCtkLastCartSignature) return;
        sbCtkLastCartSignature = sig;
        await sbBuildRelatedRecs(cart);
      } catch (err) {
        console.error('SunBorn You May Also Like: cart-signature check failed', err);
      }
    }

    window.sbMaybeRebuildRelatedRecs = sbMaybeRebuildRelatedRecs;

    /* 9/30: wait for cart intent (was: run on every page load) */
    window.sbWhenCartIntent(function () { sbMaybeRebuildRelatedRecs(); });
  });

/* ---------- Block 2 ---------- */
document.addEventListener('DOMContentLoaded', function () {
    var sbSwapProductCache = {};
    var sbSwapSizeGuideCache = {};
    var sbSwapInFlight = {};

    function sbSwapOptionName(opt) {
      if (typeof opt === 'string') return opt;
      if (opt && typeof opt === 'object' && typeof opt.name === 'string') return opt.name;
      return '';
    }

    var SB_SWAP_COLOR_LABELS = [
      'color', 'colour', 'couleur', 'cor', 'colore', 'farbe',
      '색', '色', 'カラー', 'färg', 'farve', 'szín', 'barva'
    ];

    /* PRIMARY (body) color per name. */
    var SB_SWAP_COLOR_HEX = {
      'Royal Purple': '#6E4FA8',
      'Adaeze Pink': '#FEA6A9',
      'Sango Orange': '#C45500',
      'Oji Black': '#111111',
      'Eze Pink': '#FEA6A9',
      'Ocha White': '#F5F1E8',
      'Igwe Blue': '#A3BED2',
      'Ugo Purple': '#522760',
      'Ntụ Gray': '#B2AFAA',
      'Anụnụ Blue': '#171F2C',
      'Aja Sand': '#E7DED0',
      'Natural': '#DFCEA6',
      'Ubi Green': '#6A561C',
      'Black': '#111111',
      'White': '#FFFFFF',
      'Pink': '#FFC0CB',
      'Grey': '#8C8C8C',
      'Gray': '#8C8C8C',
      'Navy': '#14213D',
      'Red': '#C1272D',
      'Orange': '#E8641A',
      'Yellow': '#FFD400',
      'Green': '#2E7D32',
      'Blue': '#1D5FAD',
      'Purple': '#6E4FA8',
      'Brown': '#6B4226',
      'Solid Black Triblend': '#1A1A1A',
      'Teal Triblend': '#127C77',
      'Athletic Grey Triblend': '#8C8C8C',
      'Oji Black/Natural': '#111111',
      'Ihie Red/Natural': '#C1272D',
      'Anụnụ Blue/Natural': '#171F2C',
      'Ndụ Green/Natural': '#1F4D2E'
    };

    /* SECONDARY (trim) color per name -- ADDED 9/19. Only two-tone names
       need an entry here; every solid colorway simply has no entry, and
       sbSwapColorHex2() below falls back to the SAME primary hex for
       those, so the CSS gradient rule (.sb-swap-swatch in
       assets/sunborn-minicart.css, V5) degenerates to a visually solid
       fill through the exact same code path -- no separate branching
       needed anywhere. Values here match the trim color already locked
       in the real two-tone gradient rules in
       assets/sunborn-swatch-color-fix.css (the PDP/grid swatch source
       of truth), so the minicart swatch now matches the PDP swatch
       exactly instead of approximating it as a flat single color. */
    var SB_SWAP_COLOR_HEX_2 = {
      'Oji Black/Natural': '#DFCEA6',
      'Ihie Red/Natural': '#DFCEA6',
      'Anụnụ Blue/Natural': '#DFCEA6',
      'Ndụ Green/Natural': '#DFCEA6'
    };

    function sbSwapColorHex(name) {
      var clean = (name || '').replace(/[\u2122\u00AE]/g, '').trim();
      return SB_SWAP_COLOR_HEX[clean] || '#999999';
    }

    /* ADDED 9/19 -- see SB_SWAP_COLOR_HEX_2 comment above for the full
       "why". Falls back to the PRIMARY color (not a gray placeholder)
       for any name with no two-tone entry, so a solid swatch's gradient
       is two identical color stops -- visually indistinguishable from a
       flat fill. */
    function sbSwapColorHex2(name) {
      var clean = (name || '').replace(/[\u2122\u00AE]/g, '').trim();
      return SB_SWAP_COLOR_HEX_2[clean] || sbSwapColorHex(name);
    }

    var SB_SWAP_GUIDE_ICON_SVG =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M8.5 3.5 5 6 3 9l2.5 2 1.5-1.5V20.5h10V9.5L18.5 11 21 9l-2-3-3.5-2.5c0 1.5-1.6 2.5-3.5 2.5s-3.5-1-3.5-2.5Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" stroke-linecap="round"/>' +
      '<path d="M7.5 13h9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-dasharray="2 1.6"/>' +
      '</svg>';

    function sbSwapMoney(cents) {
      try {
        return Shopify.formatMoney(cents, window.money_format);
      } catch (e) {
        return cents;
      }
    }

    function sbSwapFetchProduct(handle) {
      if (sbSwapProductCache[handle]) return Promise.resolve(sbSwapProductCache[handle]);
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { sbSwapProductCache[handle] = p; return p; });
    }

    function sbSwapFetchSizeGuide(handle) {
      if (Object.prototype.hasOwnProperty.call(sbSwapSizeGuideCache, handle)) {
        return Promise.resolve(sbSwapSizeGuideCache[handle]);
      }
      return fetch('/products/' + handle)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var img = doc.getElementById('sunborn-size-guide-source');
          var src = img ? img.getAttribute('src') : null;
          sbSwapSizeGuideCache[handle] = src;
          return src;
        })
        .catch(function () {
          sbSwapSizeGuideCache[handle] = null;
          return null;
        });
    }

    function sbSwapShowSizeGuide(handle, productTitle) {
      var existing = document.querySelector('.sb-sizeguide-overlay');
      if (existing) existing.remove();

      var overlay = document.createElement('div');
      overlay.className = 'sb-sizeguide-overlay';
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) overlay.remove();
      });

      var modal = document.createElement('div');
      modal.className = 'sb-sizeguide-modal';
      modal.innerHTML =
        '<div class="sb-sg-header">' +
          '<span class="sb-sg-title">SIZE GUIDE // ' + (productTitle || '').toUpperCase().slice(0, 30) + '</span>' +
          '<button type="button" class="sb-sg-close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="sb-sg-body"><div class="sb-sg-loading">Loading size guide...</div></div>';

      overlay.appendChild(modal);
      document.body.appendChild(overlay);
      modal.querySelector('.sb-sg-close').addEventListener('click', function () {
        overlay.remove();
      });

      sbSwapFetchSizeGuide(handle).then(function (src) {
        var body = modal.querySelector('.sb-sg-body');
        if (!body) return;
        body.innerHTML = src
          ? '<img src="' + src + '" alt="Size Guide">'
          : '<div class="sb-sg-loading">No size guide available for this product.</div>';
      });

      var escHandler = function (e) {
        if (e.key === 'Escape') {
          overlay.remove();
          document.removeEventListener('keydown', escHandler);
        }
      };
      document.addEventListener('keydown', escHandler);
    }

    function sbSwapVariant(lineKey, newVariantId, quantity, controlsEl) {
      if (sbSwapInFlight[lineKey]) return;
      sbSwapInFlight[lineKey] = true;
      if (controlsEl) {
        controlsEl.querySelectorAll('.sb-swap-pill').forEach(function (p) {
          p.classList.add('is-loading');
        });
      }

      /* 9/30 FIX: single atomic /cart/update.js swap. The old version did
         update.js (old line -> 0) THEN /cart/add.js (new variant), and every
         /cart/add.js call makes Shopify emit a product_added_to_cart event,
         so each drawer size/color swap was reported to Meta/TikTok/Pinterest
         as a brand-new Add To Cart. Now one update.js call zeroes the old
         line and sets the new variant's quantity in the same request
         (keys may mix line-item keys and variant IDs). If the new variant
         is already a separate line in the cart, its quantity is merged. */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {};
          updates[lineKey] = 0;
          var existing = (cart.items || []).find(function (i) {
            return String(i.variant_id) === String(newVariantId) && i.key !== lineKey;
          });
          updates[String(newVariantId)] = (existing ? existing.quantity : 0) + quantity;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('SunBorn variant swap: atomic update failed');
          return res.json();
        })
        .then(function () {
          if (typeof window.sbRefreshDrawer === 'function') {
            return window.sbRefreshDrawer();
          }
        })
        .catch(function (err) {
          console.error('SunBorn cart line-item variant swap failed:', err);
          if (controlsEl) {
            controlsEl.querySelectorAll('.sb-swap-pill').forEach(function (p) {
              p.classList.remove('is-loading');
            });
          }
        })
        .finally(function () {
          sbSwapInFlight[lineKey] = false;
        });
    }

    function sbSwapOptionIndexes(product) {
      var options = product.options || [];
      var colorIdx = -1;
      var sizeIdx = -1;
      var nonColorCount = 0;
      options.forEach(function (opt, idx) {
        var down = sbSwapOptionName(opt).toLowerCase();
        if (SB_SWAP_COLOR_LABELS.indexOf(down) > -1) {
          colorIdx = idx;
        } else {
          nonColorCount++;
          if (sizeIdx === -1) sizeIdx = idx;
        }
      });
      return { colorIdx: colorIdx, sizeIdx: sizeIdx, nonColorCount: nonColorCount };
    }

    function sbSwapFindVariant(product, sizeIdx, colorIdx, sizeVal, colorVal) {
      var sizeKey = sizeIdx > -1 ? 'option' + (sizeIdx + 1) : null;
      var colorKey = colorIdx > -1 ? 'option' + (colorIdx + 1) : null;
      return (product.variants || []).find(function (v) {
        var sizeMatch = !sizeKey || v[sizeKey] === sizeVal;
        var colorMatch = !colorKey || v[colorKey] === colorVal;
        return sizeMatch && colorMatch;
      });
    }

    function sbSwapRenderPills(wrap, product, idx, item, state) {
      wrap.querySelectorAll('.sb-swap-row').forEach(function (r) { r.remove(); });

      if (idx.sizeIdx > -1) {
        var sizeKey = 'option' + (idx.sizeIdx + 1);
        var sizeRow = document.createElement('div');
        sizeRow.className = 'sb-swap-row sb-swap-row-size';

        if (state.guideSrc) {
          var sgBtn = document.createElement('button');
          sgBtn.type = 'button';
          sgBtn.className = 'sb-swap-guide-btn';
          sgBtn.setAttribute('aria-label', 'Size guide for ' + product.title);
          sgBtn.innerHTML = SB_SWAP_GUIDE_ICON_SVG;
          sgBtn.addEventListener('click', function () {
            sbSwapShowSizeGuide(item.handle, product.title);
          });
          sizeRow.appendChild(sgBtn);
        }

        var seenSizes = {};
        product.variants.forEach(function (v) {
          var val = v[sizeKey];
          if (val == null || seenSizes[val]) return;
          seenSizes[val] = true;

          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'sb-swap-pill';
          pill.textContent = val;
          if (val === state.size) pill.classList.add('is-active');

          var target = sbSwapFindVariant(product, idx.sizeIdx, idx.colorIdx, val, state.color);
          if (!target || !target.available) pill.classList.add('is-sold-out');

          pill.addEventListener('click', function () {
            if (pill.classList.contains('is-active') || pill.classList.contains('is-loading') || pill.classList.contains('is-sold-out')) return;
            if (!target) return;
            state.size = val;
            sbSwapVariant(item.key, target.id, item.quantity, wrap);
          });

          sizeRow.appendChild(pill);
        });
        wrap.appendChild(sizeRow);
      }

      if (idx.colorIdx > -1) {
        var colorKey = 'option' + (idx.colorIdx + 1);
        var colorRow = document.createElement('div');
        colorRow.className = 'sb-swap-row sb-swap-row-color';
        var seenColors = {};
        product.variants.forEach(function (v) {
          var val = v[colorKey];
          if (val == null || seenColors[val]) return;
          seenColors[val] = true;

          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'sb-swap-pill sb-swap-swatch';
          pill.style.setProperty('--sb-swatch-color', sbSwapColorHex(val));
          pill.style.setProperty('--sb-swatch-color-2', sbSwapColorHex2(val)); /* ADDED 9/19 -- feeds the two-tone gradient CSS rule; see SB_SWAP_COLOR_HEX_2 comment above */
          pill.setAttribute('aria-label', val);
          pill.title = val;
          if (val === state.color) pill.classList.add('is-active');

          var matchAtCurrentSize = sbSwapFindVariant(product, idx.sizeIdx, idx.colorIdx, state.size, val);
          if (!matchAtCurrentSize) pill.classList.add('is-sold-out');

          pill.addEventListener('click', function () {
            if (pill.classList.contains('is-active') || pill.classList.contains('is-loading')) return;
            var target = sbSwapFindVariant(product, idx.sizeIdx, idx.colorIdx, state.size, val);
            state.color = val;
            if (target) {
              sbSwapVariant(item.key, target.id, item.quantity, wrap);
            } else {
              sbSwapRenderPills(wrap, product, idx, item, state);
            }
          });

          colorRow.appendChild(pill);
        });
        wrap.appendChild(colorRow);
      }
    }

    function sbSwapBuild(cardEl, item, product) {
      if (cardEl.querySelector('.sb-swap')) return;
      if (!product.variants || product.variants.length <= 1) return;

      var idx = sbSwapOptionIndexes(product);
      if (idx.nonColorCount >= 2) return;
      if (idx.sizeIdx === -1 && idx.colorIdx === -1) return;

      var currentVariant = product.variants.find(function (v) { return v.id === item.variant_id; });
      if (!currentVariant) return;

      var state = {
        size: idx.sizeIdx > -1 ? currentVariant['option' + (idx.sizeIdx + 1)] : null,
        color: idx.colorIdx > -1 ? currentVariant['option' + (idx.colorIdx + 1)] : null,
        guideSrc: undefined
      };

      var wrap = document.createElement('div');
      wrap.className = 'sb-swap';

      var bottomRow = cardEl.querySelector('.sb-cart-item-bottom-row');
      if (bottomRow) {
        cardEl.insertBefore(wrap, bottomRow);
      } else {
        cardEl.appendChild(wrap);
      }

      sbSwapRenderPills(wrap, product, idx, item, state);

      sbSwapFetchSizeGuide(item.handle).then(function (src) {
        state.guideSrc = src;
        if (src && wrap.isConnected) {
          sbSwapRenderPills(wrap, product, idx, item, state);
        }
      });

      var optionText = cardEl.querySelector('.item-option');
      if (optionText) optionText.style.display = 'none';
    }

    function sbSwapInjectAll() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* 9/30: match DOM lines to cart lines by variant id (the drawer
             may have re-ordered lines — see assets/sunborn-cart-order.js) */
          var byVariant = {};
          (cart.items || []).forEach(function (it) {
            if (!byVariant[String(it.variant_id)]) byVariant[String(it.variant_id)] = it;
          });
          var domItems = document.querySelectorAll('#ajaxcart-cartitems .cart-item');
          Array.prototype.forEach.call(domItems, function (el, i) {
            var inp = el.querySelector('[data-quantity-variant-id]');
            var item = inp ? byVariant[inp.getAttribute('data-quantity-variant-id')] : cart.items[i];
            if (!item || item.product_has_only_default_variant) return;
            if (el.querySelector('.sb-swap')) return;
            var infoEl = el.querySelector('.product-information');
            if (!infoEl) return;
            sbSwapFetchProduct(item.handle).then(function (product) {
              sbSwapBuild(infoEl, item, product);
            });
          });
        })
        .catch(function (err) {
          console.error('SunBorn cart line-item variant swapper: inject failed', err);
        });
    }

    window.sbSwapInjectAll = sbSwapInjectAll;

    var sbSwapOrigRefresh = window.sbRefreshDrawer;
    if (typeof sbSwapOrigRefresh === 'function') {
      window.sbRefreshDrawer = function (opts) {
        return sbSwapOrigRefresh(opts).then(function (res) {
          setTimeout(sbSwapInjectAll, 60);
          return res;
        });
      };
    }

    /* 9/30: wait for cart intent (was: run on every page load) */
    window.sbWhenCartIntent(sbSwapInjectAll);
  });
